import {useModal} from '@hm/fundamental'
import {useEffect, useState} from 'react'

export const useWelcomeFlow = () => {
  const {isOpen, openModal, closeModal} = useModal(false)
  const [step, setStep] = useState<'intro' | 'selectPersona' | undefined>()

  useEffect(() => {
    openModal()
    setStep('intro')
  }, [openModal])

  return {
    isOpen,
    closeModal: () => {
      closeModal()
      setStep('intro')
    },
    step,
    setStep
  }
}
